module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top",
    attrs: {
      "dialog": "modal-lg",
      "footer": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v("Edit Cancellation Reason")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "col-sm-12 py-3"
  }, [_c('cancellation-reasons-form', {
    attrs: {
      "reason": _vm.tempReason,
      "reasonTypesOptions": _vm.getReasonTypesOptions
    },
    on: {
      "canSaveReason": function($event) {
        _vm.canSaveReason = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center justify-content-end",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn cancel wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-7cc66fbd", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cc66fbd"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/cancellationReasons/editCancellationReason.vue
// module id = 2181
// module chunks = 0